import type { RelativeTimeI18nKeys } from '@framework/i18n/formatRelativeTime';

export const MODEL_COMMENT_RELATIVE_TIME_I18N_KEYS = {
  minutes: 'canvas.comment.relativeTime.minutes',
  hours: 'canvas.comment.relativeTime.hours',
  days: 'canvas.comment.relativeTime.days',
  weeks: 'canvas.comment.relativeTime.weeks',
  months: 'canvas.comment.relativeTime.months',
  years: 'canvas.comment.relativeTime.years',
} as const satisfies RelativeTimeI18nKeys;
